import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setEmptyServices,
  setServices,
} from "../../../reducers/services/servicesSlices";
import { setAddServices } from "../../../reducers/services/addservicesSlices";
import {
  cleanCodeAuth,
  setCodeAuth,
} from "../../../reducers/authorization/codeauthorizationSlices";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";
import { setLogoutUserSession } from "../../../reducers/sessions/sessionauthcodeSlices";
import { setLogoutAuthCode } from "../../../reducers/authorization/authorizationcodeSlices";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  BaseUrlAuth,
  BaseUrlServ,
} from "../../../services/axios/AxiosEndpoints";
import {
  Box,
  Stack,
  Typography,
  Autocomplete,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  tableCellClasses,
  Container,
  Button,
} from "@mui/material";
import styled from "@emotion/styled";
import {
  cleanUpdateAuth,
  setUpdateAuth,
} from "../../../reducers/authorization/updateautorizacionSlices";
import DOMPurify from "dompurify";
import printJS from "print-js";
import ViewerTicketReport from "../PrintFiles/ViewerTicketReport";
import { CleanReprintReportData, ReprintReportData } from "../../../reducers/reports/reprintreport";

const FormAddServices = () => {
  const linkPDFRef = useRef(null);
  /* hook para disparar las funciones almacenados en redux */
  const dispatch = useDispatch();
  /* datos almacenados en redux */
  const { codPss } = useSelector((state) => state.user);
  const { plastico, message } = useSelector((state) => state.authcode);
  const { codauth, mensage } = useSelector((state) => state.codeauth);
  const { usersession } = useSelector((state) => state.sessionuser);
  const { services } = useSelector((state) => state.services);
  const { autorizacion, coddia, diagno, mesage } = useSelector((state) => state.services);
  /* Campo para el diagnostico */
  const [diagnostico, setDiagnostico] = useState("");
  /* Campo para la descripcion del diagnostico */
  const [describDiagn, setDescribDiagn] = useState("");
  /* Campo para el telefono */
  const [telefono, setTelefono] = useState("");
  /* Campo para el grupo medico */
  const [gruposMedicos, setGruposMedicos] = useState("");
  /* Campo para el grupo medico */
  const [codigoGrupo, setCodigoGrupo] = useState("");
  /* Campo para el grupo medico */
  const [codigoOrigenGrupo, setCodigoOrigenGrupo] = useState("");
  /* Campo para el grupo medico */
  const [codigoSubGrupo, setCodigoSubGrupo] = useState("");
  /* Mensajes de status del formulario cuando se cargo un servicio a la tabla */
  const [Respuesta, setRespuesta] = useState("");
  /* Mensajes de status del formulario elegir un servicio con envio de código */
  const [MsgValidProced, setMsgValidProced] = useState("");
  /* Mensajes de status del formulario validar código */
  const [Mensaje, setMensaje] = useState("");
  /* Lista de servicios */
  const [cargarServices, setCargarServices] = useState([]);
  /* Lista de procedimientos cargadas a la tabla */
  const [cargarDatos, setCargarDatos] = useState([]);
  /* Variable que guarda el código del procedimiento al seleccionarlo */
  const [Proced, setProced] = useState([]);
  /* Variable que guarda el código de sesion al seleccionarlo */
  const [listaDiag, setListaDiag] = useState();
  /* Variebles que sumaran el total de cada monto de la tabla y la suma total de los montos */
  const [codSesion, setCodSesion] = useState("");
  /* Variebles que almacena los datos que devuelve el servidor al cerrar sesion */
  const [contentClosedSesion, setSontentClosedSesion] = useState({});
  /* Variebles que almacena el estado de la peticion update autorizacion al cerrar sesion */
  const [statusUpdateAuth, setStatusUpdateAuth] = useState("");
  /* variable que retorna la posicion de la tabla a eliminar */
  const [position, setPosition] = useState(0);
  /* variable que almacena el plastico para el uso de atuorizacion */
  const [newPlastico, setNewPlastico] = useState("");
  /* variable que almacena el plastico para el uso de atuorizacion */
  const [newOpenFrec, setNewOpenFrec] = useState("");
  /* variable que modifica la frecuencia */
  const [frecuencia, setFrecuencia] = useState(0);
  /* variable que abre el campo frecuencia */
  const [openCampFrec, setOpenCampFrec] = useState();
  /* Variable que almacena los datos */
  const [DatosImpre, setDatosImpre] = useState({});
  /* variable que muestra la cantidad de datos que contiene */
  const cantidadDatos = cargarDatos.length;
  /* Objeto de datos que se envian al formulario para validar el procedimiento */
  const [datos, setDatos] = useState({
    codSesion: usersession.codSesion,
    frecuencia: frecuencia,
    procedimiento: Proced,
  });
  /* Objeto de atos que se envian al formulario para eliminar un procedimiento */
  const [deleteProced, setDeleteProced] = useState({
    codSesion: "",
    procedimiento: "",
  });
  /* Variebles que sumaran el total de cada monto de la tabla y la suma total de los montos */
  const [montoRecTotal, setMontoRecTotal] = useState();
  const [montoARSTotal, setMontoARSTotal] = useState();
  const [montoAfilTotal, setMontoAfilTotal] = useState();

  /* ------------------------------------ Validacion ------------------------------------  */

  const validate = () => {
    const errors = {};

    if (!describDiagn) {
      errors.describDiagn = "Por favor, llenar este campo para continuar.";
    }

    return errors;
  };

  /* ------------------------------------ Estilos de las tablas ------------------------------------  */

  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#46cffa",
      color: "#fff",
    },
  }));

  const StyledTableRow = styled(TableRow)(() => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#f5f5f5",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  /* ------------------------------------ Funciones para crear e imprimir el ticket ------------------------------------ */

  const imprimirContenido = () => {
    printJS({
      printable: "contenidoParaImprimir",
      // ID del elemento que deseas imprimir
      type: "html",
    });
  };

  /* ------------------------------------ Formulario para cargar los servicios en el input select -------------------------------- */

  useEffect(() => {
    if (codigoGrupo && codPss) {
      const sanitizedCodPss = DOMPurify.sanitize(codPss);
      const sanitizedCodGroup = DOMPurify.sanitize(codigoGrupo);

      axios({
        url: `${BaseUrlServ}/listaProcedimiento`,
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          codpss: sanitizedCodPss,
          codgru: sanitizedCodGroup,
        }),
      })
        .then((response) => {
          if (message === "OK") {
            if (response.status === 200) {
              const { value } = response.data;
              setCargarServices(value);
              dispatch(setAddServices(value));
              setNewPlastico(plastico);
              setMensaje(message);
            } else {
              let codpssError = "Código de autorización inválido";
              setMensaje(codpssError);
              Swal.fire({
                title: "",
                text: codpssError,
                icon: "warning",
                confirmButtonText: "Ok",
              });
            }
          } else if (diagnostico === "" && describDiagn === "") {
            let codpssError = "Primero debe validar el afiliado.";
            setMensaje(codpssError);
            Swal.fire({
              title: "",
              text: codpssError,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 400) {
              let codpssError = "El recurso no fue encontrado.";
              setMensaje(codpssError);
            } else if (error.response.status === 500) {
              let codpssError = "Ha ocurrido un error en el servidor";
              setMensaje(codpssError);
            }

            const { resp } = error.response.data;
            setMensaje(resp.detalle);
            Swal.fire({
              title: "",
              text: resp.detalle,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
          }
        });
    }
  }, [
    codPss,
    codigoGrupo,
    describDiagn,
    diagnostico,
    dispatch,
    message,
    plastico,
  ]);

  /* --------------------------------- Formulario para validar el procedimiento ------------------------------ */

  const HandleSubmitValidarProced = async (e) => {
    e.preventDefault();

    const sanitizedCodSesion = DOMPurify.sanitize(datos.codSesion);
    const sanitizedFrec = parseInt(DOMPurify.sanitize(frecuencia ? frecuencia : newOpenFrec));
    const sanitizedProced = DOMPurify.sanitize(datos.procedimiento);

    if (telefono !== "") {
      await axios({
        url: `${BaseUrlAuth}/validarProcedimiento`,
        method: "POST",
        data: {
          codSesion: sanitizedCodSesion,
          frecuencia: sanitizedFrec,
          procedimiento: sanitizedProced,
        },
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (plastico !== "") {
            if (response.status === 200) {
              setCargarDatos([...cargarDatos, response.data]);
              if (frecuencia) {
                setCargarDatos((prevDatos) => {
                  const nuevosDatos = [...prevDatos];
                  nuevosDatos[cantidadDatos] = {
                    ...nuevosDatos[cantidadDatos],
                    frecuencia: parseInt(frecuencia),
                  };
                  return nuevosDatos;
                });
              } else {
                setCargarDatos((prevDatos) => {
                  const nuevosDatos = [...prevDatos];
                  nuevosDatos[cantidadDatos] = {
                    ...nuevosDatos[cantidadDatos],
                    frecuencia: parseInt(newOpenFrec),
                  };
                  return nuevosDatos;
                });
              }

              setOpenCampFrec();
              setFrecuencia();
              const { resp } = response.data;
              setMsgValidProced(resp.mensaje);
              setRespuesta(resp.mensaje);
            } else {
              let mensajeError = "Error de validacion de procedimiento";
              setMsgValidProced(mensajeError);
            }
          } else {
            let mensajeError = "Primero debe validar el afiliado.";
            setMsgValidProced(mensajeError);
            Swal.fire({
              title: "",
              text: mensajeError,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 422) {
              setMsgValidProced("El recurso no fue encontrado.");
            } else if (error.response.status === 500) {
              setMsgValidProced("Ha ocurrido un error en el servidor");
            }

            const { resp } = error.response.data;
            setMsgValidProced(resp.detalle);
            Swal.fire({
              title: "",
              text: resp.detalle,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
          }
        });
    } else {
      let mensajeError = "El campo de telefono no puede estar vacio.";
      setMsgValidProced(mensajeError);
      Swal.fire({
        title: "",
        text: mensajeError,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
  };

  /* --------------------------------- funcion para seleccionar un procedimiento ------------------------------ */

  const handleOptionSelect = (event, newValue) => {
    if (newValue) {
      setProced(newValue.codproc);
    }
    if (newValue.diasmi === "0") {
      setOpenCampFrec(newValue.diasmi);
    } else {
      setNewOpenFrec(newValue.diasmi);
      setProced(newValue.codproc);
    }
  };

  /* --------------------------------- funcion para editar la frecuencia del servicio ------------------------------ */

  const HandleAddFrecuencia = (e) => {
    const { value } = e.target;
    if (openCampFrec === "0") {
      setFrecuencia(value);
    }
  };

  /* --------------------------------- funcion para agregar un procedimiento a la tabla ------------------------------ */

  const HandleAddTable = () => {
    if (plastico === newPlastico) {
      if (datos.procedimiento === "" && openCampFrec === "0") {
        setDatos({
          codSesion: usersession.codSesion,
          frecuencia: parseInt(frecuencia),
          procedimiento: Proced.toString(),
        });
      } else {
        setDatos({
          codSesion: usersession.codSesion,
          frecuencia: parseInt(newOpenFrec),
          procedimiento: Proced.toString(),
        });
      }
    } else {
      Swal.fire({
        title: "",
        text: "Una vez cargados los datos no puede cambiar de usuario.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
  };

  /* --------------------------------- funcion para validar si la tabla no esta vacia para cancelar ------------------------------ */

  const HandleValidContentTable = () => {
    if (Respuesta !== "OK") {
      Swal.fire({
        title: "Aviso!",
        text: "Debe seleccionar al menos un procedimiento",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
  };

  /* --------------------------------- Validaciones ------------------------------ */

  useEffect(() => {
    /* --------------------------------- funcion para validar si la tabla tiene 40 servicios o menos ------------------------------ */

    if (cargarDatos.length === 40) {
      Swal.fire({
        title: "",
        text: "ha alcanzado el número máximo de servicios permitidos por autorización, si desea incluir más mas servicios debe crear otra autorización.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }

    /* --------------------------------- funcion para validar si el monto de cobertura no excede los 30,000 ------------------------------ */

    if (parseInt(montoARSTotal) >= 30000) {
      Swal.fire({
        title: "",
        text: "ha alcanzado el monto de cobertura máximo por autorización, si desea incluir más mas servicios debe crear otra autorización.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }

    /* --------------------------------- funcion para validar si la frecuencia es mayor a 10 ------------------------------ */

    if (frecuencia > 10) {
      setFrecuencia(0);
      Swal.fire({
        title: "",
        text: "La frecuencia que ha colocado no está permitida por esta vía.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
  }, [cargarDatos, montoARSTotal, frecuencia]);

  /* --------------------------------- Formulario para refrescar la pantalla, imprimir el Ticket y borrar los datos ------------------------------ */

  const HandleRefreshAfterTicket = () => {
    Swal.fire({
      title: "IMPRIMIR TICKET",
      text: "En caso de cancelar la impresión puede dirigirse a 'Consultas Aut' en el menú de consultas con el código de autorización para imprimir el ticket.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "NO",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        imprimirContenido();

        setDatos({});

        setDatosImpre({});

        setTimeout(() => {
          dispatch(
            setLogoutUserSession({
              usersession: usersession,
            })
          );

          dispatch(
            setLogoutAuthCode({
              plastico: plastico,
              mensage: message,
            })
          );

          dispatch(
            CleanReprintReportData({
              reprintdata: DatosImpre,
            })
          );

          dispatch(cleanUpdateAuth());

          dispatch(cleanCodeAuth());

          dispatch(setEmptyServices(services));

          window.location.reload();
        }, 3000);
      }
    });
  };

  /* --------------------------------- Formulario para refrescar la pantalla, imprimir el PDF y borrar los datos ------------------------------ */

  const HandleRefreshAfterPDF = () => {
    linkPDFRef.current.click();

    setDatos({});

    setDatosImpre({});

    setTimeout(() => {
      dispatch(
        setLogoutUserSession({
          usersession: usersession,
        })
      );

      dispatch(
        setLogoutAuthCode({
          plastico: plastico,
          mensage: message,
        })
      );

      dispatch(
        CleanReprintReportData({
          reprintdata: {},
        })
      );

      dispatch(cleanUpdateAuth());

      dispatch(cleanCodeAuth());

      dispatch(setEmptyServices(services));

      window.location.reload();
    }, 3000);
  };

  /* --------------------------------- Formulario para refrescar la pantalla y borrar los datos ------------------------------ */

  const HandleRefreshWindows = () => {
    setTimeout(() => {
      dispatch(
        setLogoutUserSession({
          usersession: usersession,
        })
      );

      dispatch(
        setLogoutAuthCode({
          plastico: plastico,
          mensage: message,
        })
      );

      dispatch(
        CleanReprintReportData({
          reprintdata: {},
        })
      );

      dispatch(cleanUpdateAuth());

      dispatch(cleanCodeAuth());

      dispatch(setEmptyServices(services));

      window.location.reload();
    }, 3000);
  };

  /* --------------------------------- Funcion para eliminar un procedimiento de la tabla ------------------------------ */
  /* El código del procedimiento tiene que ser el mismo que la linea a eliminar en la tabla, osea su posicion */

  const HandleDeleteTable = (indexItem) => {
    if (cargarDatos[indexItem].procedimiento) {
      setPosition(indexItem);
      setDeleteProced({
        codSesion: usersession.codSesion,
        procedimiento: cargarDatos[indexItem].procedimiento,
      });
    }
  };

  /* --------------------------------- Formulario para eliminar un procedimiento de la tabla ------------------------------ */

  const HandleSubmitEliminarProced = (e) => {
    e.preventDefault();

    const sanitizedCodSesion = DOMPurify.sanitize(deleteProced.codSesion);
    const sanitizedProced = DOMPurify.sanitize(deleteProced.procedimiento);

    Swal.fire({
      title: "ELIMINAR REGISTRO",
      text: "¿Está seguro que quiere eliminar el servicio médico? Una vez que lo elimine, no podrá recuperarlo.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "NO",
      confirmButtonText: "Si, eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          url: `${BaseUrlAuth}/cancelarProcedimiento`,
          method: "POST",
          data: JSON.stringify({
            codSesion: sanitizedCodSesion,
            procedimiento: sanitizedProced,
          }),
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "http://localhost:3000/",
          },
        })
          .then((response) => {
            if (response.status === 200) {
              if (position) {
                setCargarDatos((prevState) =>
                  prevState.filter((todo, inicio) => inicio !== position)
                );
              } else if (!position) {
                setCargarDatos((prevState) =>
                  prevState.filter((todo, inicio) => inicio !== position)
                );
              } else {
                setCargarDatos([]);
              }
            }
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status === 400) {
                setMsgValidProced("El recurso no fue encontrado.");
              } else if (error.response.status === 500) {
                setMsgValidProced("Ha ocurrido un error en el servidor");
              }

              const { resp } = error.response.data;
              setMsgValidProced(resp.detalle);
              Swal.fire({
                title: "",
                text: resp.detalle,
                icon: "warning",
                confirmButtonText: "Ok",
              });
            } else if (error.request) {
            }
          });

        Swal.fire({
          title: "Éxito",
          text: "Registro eliminado correctamente.",
          icon: "success",
          confirmButtonText: "Ok",
        });
      }
    });
  };

  /* --------------------------------- Funcion capturar el codigo y el nombre del diagnostico ------------------------------ */

  const HandleChangeDiagnostico = (event, newValue) => {
    if (newValue && newValue.codigo !== "Z777") {
      setDiagnostico(newValue.codigo);
      setDescribDiagn(newValue.nombre);
    } else {
      setDiagnostico(null);
    }
  };

  /* --------------------------------- Funcion el numero telefonico del solicitante ------------------------------ */

  const HandleChangeTelefono = (event) => {
    if (plastico !== "") {
      // Obtén el valor actual del campo de identificación
      let { value } = event.target;

      // Elimina los guiones existentes y cualquier carácter que no sea un número
      value = value.replace(/[^0-9]/g, "");

      // Agrega guiones en las posiciones correspondientes
      if (value.length > 3 && value.length <= 6) {
        value = `${value.slice(0, 3)}-${value.slice(3)}`;
      } else if (value.length > 6 && value.length <= 10) {
        value = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
      }
      // Actualiza el estado con el nuevo valor formateado
      setTelefono(value);
    } else {
      let codpssError = "Primero debe validar el afiliado.";
      setMensaje(codpssError);
      Swal.fire({
        title: "",
        text: codpssError,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
  };

  /* --------------------------------- Funcion para cambiar de diagnostico ------------------------------ */

  const HandleChangeOtros = (event) => {
    setDescribDiagn(event.target.value);
  };

  /* --------------------------------- Lista de diagnosticos ------------------------------ */

  useEffect(() => {
    if (plastico !== "") {
      axios({
        url: `${BaseUrlServ}/listarDiagnostico`,
        method: "GET",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            setListaDiag(response.data.value);
          } else {
            Swal.fire({
              title: "",
              text: "El recurso no fue encontrado.",
              icon: "warning",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 422) {
              setMsgValidProced("El recurso no fue encontrado.");
            } else if (error.response.status === 500) {
              setMsgValidProced("Ha ocurrido un error en el servidor");
            }

            const { resp } = error.response.data;
            setMsgValidProced(resp.msg);
            Swal.fire({
              title: "",
              text: resp.msg,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
            setMsgValidProced(error.request);
            Swal.fire({
              title: "",
              text: error.request,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          }
        });
    }
  }, [plastico]);

  /* --------------------------------- grupo medico seleccionado ------------------------------ */

  const HandleSelectGrupoMedico = (event, newValue) => {
    if (newValue) {
      setCodigoGrupo(newValue.codigo);
      setCodigoOrigenGrupo(newValue.codori);
      setCodigoSubGrupo(newValue.codsub);
    } else {
      setCodigoGrupo(null);
    }
  };

  /* --------------------------------- Lista de grupos medicos ------------------------------ */

  useEffect(() => {
    if (diagnostico !== "") {
      axios({
        url: `${BaseUrlServ}/listarGrupoServicio`,
        method: "GET",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            setGruposMedicos(response.data.value);
          } else {
            Swal.fire({
              title: "",
              text: "El recurso no fue encontrado.",
              icon: "warning",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 422) {
              setMsgValidProced("El recurso no fue encontrado.");
            } else if (error.response.status === 500) {
              setMsgValidProced("Ha ocurrido un error en el servidor");
            }

            const { resp } = error.response.data;
            setMsgValidProced(resp);
            Swal.fire({
              title: "",
              text: resp.msg,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
            setMsgValidProced(error.request);
            Swal.fire({
              title: "",
              text: error.request,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          }
        });
    } else if (diagnostico === "Z777") {
      axios({
        url: `${BaseUrlServ}/listarGrupoServicio`,
        method: "GET",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            setGruposMedicos(response.data.value);
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 422) {
              setMsgValidProced("El recurso no fue encontrado.");
            } else if (error.response.status === 500) {
              setMsgValidProced("Ha ocurrido un error en el servidor");
            }

            const { resp } = error.response.data;
            setMsgValidProced(resp);
            Swal.fire({
              title: "",
              text: resp.msg,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
            setMsgValidProced(error.request);
            Swal.fire({
              title: "",
              text: error.request,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          }
        });
    }
  }, [plastico, diagnostico, telefono]);

  /* --------------------------------- Funcion para enviar los datos del solicitante al cerrar la sesion ------------------------------ */

  useEffect(() => {
    if (contentClosedSesion.codAutorizacion) {
      axios({
        url: `${BaseUrlServ}/UpdateAutorizacion`,
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        data: {
          autorizacion: JSON.stringify(contentClosedSesion.codAutorizacion),
          coddia: diagnostico,
          telefono: telefono,
          diagno: describDiagn,
          codori: codigoOrigenGrupo,
          codsub: codigoSubGrupo,
        },
      })
        .then((response) => {
          if (contentClosedSesion.codAutorizacion && diagnostico && telefono) {
            if (response.status === 200) {
              setStatusUpdateAuth(response.status);
              dispatch(
                setUpdateAuth({
                  autorizacion: contentClosedSesion.codAutorizacion,
                  coddia: diagnostico,
                  telefono: telefono,
                  diagno: describDiagn,
                  message: MsgValidProced,
                })
              );
            } else {
              let mensajeError = "Error al eliminar de procedimiento";
              setMsgValidProced(mensajeError);
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 400) {
              setMsgValidProced("El recurso no fue encontrado.");
            } else if (error.response.status === 500) {
              setMsgValidProced("Ha ocurrido un error en el servidor");
            }

            setMsgValidProced(error.response.mensaje);
            Swal.fire({
              title: "",
              text: error.response.mensaje,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
          }
        });
    }
  }, [
    MsgValidProced,
    codigoOrigenGrupo,
    codigoSubGrupo,
    contentClosedSesion.codAutorizacion,
    describDiagn,
    diagnostico,
    dispatch,
    telefono,
  ]);

  /* --------------------------------- Funcion para cerrar la sesion ------------------------------ */

  const HandleCerrarSession = () => {
    setCodSesion(usersession.codSesion);
  };

  /* --------------------------------- Funcion para enviar la peticion para cerrar la sesion ------------------------------ */

  const HandleSubmitCerrarSesion = async (e) => {
    e.preventDefault();

    const sanitizedCodSesion = DOMPurify.sanitize(codSesion);

    await axios({
      url: `${BaseUrlAuth}/cerrarSesion`,
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        codSesion: sanitizedCodSesion,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          setSontentClosedSesion(response.data);
          dispatch(setServices(cargarDatos));
          const { resp } = response.data;
          dispatch(
            setCodeAuth({
              codauth: response.data,
              mensage: resp.mensaje,
            })
          );

          setMsgValidProced(resp.mensaje);
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 400) {
            setMsgValidProced("El recurso no fue encontrado.");
          } else if (error.response.status === 500) {
            setMsgValidProced("Ha ocurrido un error en el servidor");
          }

          const { resp } = error.response.data;
          setMsgValidProced(resp.detalle);
          console.log(error.response.data);
          Swal.fire({
            title: "",
            text: "Ocurrio algo inesperado",
            icon: "warning",
            confirmButtonText: "Ok",
          });
        } else if (error.request) {
        }
      });
  };

  /* ---------------------------------  Formulario para realizar la consulta y mostrar los datos en la tabla ------------------------------ */

  useEffect(() => {
    const sanitizedCodAuth = parseInt(DOMPurify.sanitize(contentClosedSesion.codAutorizacion));

    if (contentClosedSesion.codAutorizacion && statusUpdateAuth === 200) {
      axios({
        url: `${BaseUrlServ}/ObtenerDatosReimprimir`,
        method: "POST",
        headers: {
          Accept: "*/*",
        },
        params: {
          codaut: sanitizedCodAuth,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            setDatosImpre(response.data);
            dispatch(
              ReprintReportData({
                reprintdata: response.data,
              })
            );
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 400) {
              //setMensajeOk("El recurso no fue encontrado.");
            } else if (error.response.status === 500) {
              //setMensajeOk("Ha ocurrido un error en el servidor");
            }

            //const { resp } = error.response.data;

            //setPosterror(resp.mensaje);
            Swal.fire({
              title: "",
              text: "código no autorizado o invalido",
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
          }
        });
    }
  }, [contentClosedSesion.codAutorizacion, statusUpdateAuth, dispatch]);

  /* --------------------------------- Funcion para cancelar procedimientos ------------------------------ */

  const HandleCancelarProcedimiento = (e) => {
    e.preventDefault();

    if (MsgValidProced !== "OK") {
      Swal.fire({
        title: "Aviso!",
        text: "Debe tener al menos un procedimiento en la lista.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } else {
      Swal.fire({
        title: "¿Estas seguro de esta accion?",
        text: "Una vez aceptado no se puede revertir",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            "Cancelado!",
            "Has cancelado el sguiente gestión.",
            "success"
          );
          dispatch(
            setLogoutUserSession({
              usersession: usersession,
            })
          );
          dispatch(
            setLogoutAuthCode({
              plastico: plastico,
              mensage: message,
            })
          );
          dispatch(
            cleanUpdateAuth({
              autorizacion: autorizacion,
              coddia: coddia,
              telefono: telefono,
              diagno: diagno,
              mesage: mesage,
            })
          );
          dispatch(
            cleanCodeAuth({
              codauth: codauth,
              mensage: mensage,
            })
          );

          dispatch(setEmptyServices(services));
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      });
    }
  };

  /* --------------------------------- Funcion para manejar los montos ------------------------------ */

  useEffect(() => {
    const handlemontoRec = () => {
      const sumar = cargarDatos
        .map((saldo) => parseFloat(saldo.montoReclamado))
        .reduce((previous, current) => {
          return previous + current;
        }, 0);
      setMontoRecTotal(sumar);
    };

    const handlemontoARS = () => {
      const sumar = cargarDatos
        .map((saldo) => parseFloat(saldo.montoARS))
        .reduce((previous, current) => {
          return previous + current;
        }, 0);
      setMontoARSTotal(sumar);
    };

    const handlemontoAfil = () => {
      const sumar = cargarDatos
        .map((saldo) => parseFloat(saldo.montoAfiliado))
        .reduce((previous, current) => {
          return previous + current;
        }, 0);
      setMontoAfilTotal(sumar);
    };

    handlemontoRec();
    handlemontoARS();
    handlemontoAfil();
  }, [cargarDatos]);

  return (
    <Container>
      {/* -------- Formulario para enviar estos datos al cerrar session -------- */}
      <Stack
        component="form"
        noValidate
        autoComplete="off"
        spacing={2}
        sx={{
          width: "100%",
          height: "auto",
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" },
          justifyContent: "space-around",
          alignItems: "baseline",
          marginTop: "40px",
          marginBottom: "40px",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", sm: "100%", md: "45%", lg: "45%" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              width: "auto",
              fontSize: { xs: 14, sm: 14, md: 16, lg: 16 },
              fontWeight: 500,
            }}
          >
            DIAGNÓSTICO
          </Typography>

          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            size="small"
            sx={{ width: { xs: "100%", sm: "100%", md: "300px", lg: "300px" } }}
            getOptionLabel={(option) => `${option.codigo} ${option.nombre}`}
            onChange={HandleChangeDiagnostico}
            renderInput={(params) => <TextField {...params} label="Buscar" />}
            options={listaDiag}
          />
        </Box>

        <Box
          sx={{
            width: { xs: "100%", sm: "100%", md: "45%", lg: "45%" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              width: "auto",
              fontSize: { xs: 14, sm: 14, md: 16, lg: 16 },
              fontWeight: 500,
            }}
          >
            TELÉFONO
          </Typography>
          <TextField
            size="small"
            name="telefono"
            value={telefono}
            autoComplete="telefono"
            autoFocus
            placeholder="Teléfono"
            onChange={HandleChangeTelefono}
            inputProps={{
              maxLength: 12,
            }}
            sx={{
              width: { xs: "100%", sm: "100%", md: "300px", lg: "300px" },
            }}
          />
        </Box>
      </Stack>

      {diagnostico !== "Z777" ? (
        <></>
      ) : (
        <Stack>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              marginLeft: 3,
              marginBottom: 5,
            }}
          >
            <Typography
              sx={{
                width: "auto",
                fontSize: { xs: 14, sm: 14, md: 16, lg: 16 },
                fontWeight: 500,
              }}
            >
              DESCRIBIR DIAGNÓSTICO
            </Typography>
            <TextField
              size="small"
              name="describDiagn"
              value={describDiagn}
              autoComplete="describDiagn"
              autoFocus
              placeholder="Describir"
              onChange={HandleChangeOtros}
              error
              sx={{
                width: { xs: "100%", sm: "100%", md: "300px", lg: "300px" },
              }}
              helperText={validate().describDiagn}
            />
          </Box>
        </Stack>
      )}

      <Stack
        sx={{
          width: { xs: "100%", sm: "100%", md: "45%", lg: "45%" },
          display: "flex",
          flexDirection: "column",
          marginBottom: "40px",
          marginLeft: "25px",
        }}
      >
        {cargarDatos.length === 0 &&
          diagnostico !== "" &&
          diagnostico !== "Z777" ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "column",
                lg: "column",
              },
            }}
          >
            <Typography
              sx={{
                mb: 0,
                fontSize: { xs: 14, sm: 14, md: 16, lg: 16 },
                fontWeight: 500,
              }}
            >
              GRUPO DE SERVICIOS MÉDICOS
            </Typography>

            <Autocomplete
              disablePortal
              size="small"
              id="combo-box-demo"
              sx={{
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "300px",
                  lg: "300px",
                },
                marginTop: "0px",
              }}
              getOptionLabel={(option) => `${option.codigo} ${option.nombre}`}
              onChange={HandleSelectGrupoMedico}
              renderInput={(params) => <TextField {...params} label="GRUPOS" />}
              options={gruposMedicos}
            />
          </Box>
        ) : cargarDatos.length === 0 &&
          diagnostico === "Z777" &&
          describDiagn !== "" ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "column",
                lg: "column",
              },
            }}
          >
            <Typography
              sx={{
                mb: 0,
                fontSize: { xs: 14, sm: 14, md: 16, lg: 16 },
                fontWeight: 500,
              }}
              htmlFor="gruposMedicos"
            >
              GRUPO DE SERVICIOS MÉDICOS
            </Typography>

            <Autocomplete
              disablePortal
              size="small"
              id="combo-box-demo"
              sx={{
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "300px",
                  lg: "300px",
                },
                marginTop: "0px",
              }}
              getOptionLabel={(option) => `${option.codigo} ${option.nombre}`}
              onChange={HandleSelectGrupoMedico}
              renderInput={(params) => <TextField {...params} label="GRUPOS" />}
              options={gruposMedicos}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "column",
                lg: "column",
              },
            }}
          >
            <Typography
              sx={{
                mb: 0,
                fontSize: { xs: 14, sm: 14, md: 16, lg: 16 },
                fontWeight: 500,
              }}
              htmlFor="gruposMedicos"
            >
              GRUPO DE SERVICIOS MÉDICOS
            </Typography>

            <Autocomplete
              disablePortal
              size="small"
              id="combo-box-demo"
              sx={{
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "300px",
                  lg: "300px",
                },
                marginTop: "0px",
              }}
              disabled
              getOptionLabel={(option) => `${option.codigo} ${option.nombre}`}
              onChange={HandleSelectGrupoMedico}
              renderInput={(params) => <TextField {...params} label="GRUPOS" />}
              options={gruposMedicos}
            />
          </Box>
        )}
      </Stack>

      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "100%",
          }}
        >
          {/* -------- Formulario para agregar registros a la tabla -------- */}

          {!cargarServices && !cargarServices ? (
            <ReactLoading
              type="spokes"
              color="#0000FF"
              height={100}
              width={50}
            />
          ) : (
            <Box
              sx={{
                width: "100%",
              }}
            >
              <Container
                component="form"
                onSubmit={HandleSubmitValidarProced}
                sx={{
                  width: "auto",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: {
                      xs: "column",
                      sm: "column",
                      md: "row",
                      lg: "row",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: {
                        xs: "column",
                        sm: "column",
                        md: "column",
                        lg: "column",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        mb: 0,
                        fontSize: { xs: 14, sm: 14, md: 16, lg: 16 },
                        fontWeight: 500,
                      }}
                      htmlFor="cargarServices"
                    >
                      CARGUE LOS SERVICIOS MÉDICOS
                    </Typography>

                    <Autocomplete
                      disablePortal
                      size="small"
                      id="combo-box-demo"
                      sx={{
                        width: {
                          xs: "100%",
                          sm: "100%",
                          md: "400px",
                          lg: "400px",
                        },
                        marginTop: "0px",
                      }}
                      getOptionLabel={(option) =>
                        `${option.codproc} ${option.nombre}`
                      }
                      onChange={handleOptionSelect}
                      renderInput={(params) => (
                        <TextField {...params} label="SERVICIOS" />
                      )}
                      options={cargarServices}
                    />
                  </Box>

                  {openCampFrec === "0" ? (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: {
                            xs: "column",
                            sm: "column",
                            md: "column",
                            lg: "column",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            mb: 0,
                            fontSize: {
                              xs: 14,
                              sm: 14,
                              md: 16,
                              lg: 16,
                            },
                            fontWeight: 500,
                            marginLeft: 3,
                          }}
                          htmlFor="cargarServices"
                        >
                          FRECUENCIA
                        </Typography>

                        <TextField
                          size="small"
                          name="frecuencia"
                          id="frecuencia"
                          type="number"
                          value={frecuencia}
                          required
                          autoComplete="frecuencia"
                          autoFocus
                          placeholder="frecuencia"
                          onChange={HandleAddFrecuencia}
                          sx={{
                            width: {
                              xs: "100%",
                              sm: "100%",
                              md: "80px",
                              lg: "80px",
                            },
                            left: 20,
                          }}
                        />
                      </Box>
                    </>
                  ) : (
                    <></>
                  )}

                  {cantidadDatos !== 40 && parseInt(montoARSTotal) <= 30000 ? (
                    <Box
                      sx={{
                        width: "auto",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        onClick={HandleAddTable}
                        sx={{
                          width: "auto",
                          mt: 3,
                          left: 20,
                          fontSize: {
                            xs: 12,
                            sm: 12,
                            md: 14,
                            lg: 14,
                          },
                        }}
                      >
                        AGREGAR SERVICIO
                      </Button>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        width: "auto",
                      }}
                    >
                      <Button
                        variant="contained"
                        type="button"
                        //onClick={HandleAddTable}
                        sx={{
                          width: "auto",
                          mt: 3,
                          left: 20,
                          fontSize: {
                            xs: 12,
                            sm: 12,
                            md: 14,
                            lg: 14,
                          },
                        }}
                      >
                        AGREGAR SERVICIO
                      </Button>
                    </Box>
                  )}
                </Box>
              </Container>
            </Box>
          )}

          {/* -------- seccion que lista los procedimientos agregados y el formulario para eliminar procedimientos -------- */}
          <Container
            component="form"
            onSubmit={HandleSubmitEliminarProced}
            sx={{
              width: "auto",
            }}
          >
            <Typography
              sx={{
                mt: 6,
                pb: 2,
                fontSize: { xs: 14, sm: 14, md: 16, lg: 16 },
                fontWeight: 500,
              }}
            >
              LISTA DE SERVICIOS
            </Typography>

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>CÓDIGO</StyledTableCell>
                    <StyledTableCell>NOMBRE</StyledTableCell>
                    <StyledTableCell>FRECUENCIA</StyledTableCell>
                    <StyledTableCell>VALOR DEL SERVICIO</StyledTableCell>
                    <StyledTableCell>COBERTURA ARS</StyledTableCell>
                    <StyledTableCell>DIFERENCIA AFILIADO</StyledTableCell>
                    <StyledTableCell>ELIMINAR</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(cargarDatos) ? (
                    cargarDatos.map((item, index) => (
                      <TableRow key={index}>
                        <StyledTableCell style={{ fontSize: "13px" }}>
                          {item.procedimiento}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "13px" }}>
                          {item.nombre}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "13px" }}>
                          {item.frecuencia ? item.frecuencia : frecuencia}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "13px" }}>
                          {parseFloat(item.montoReclamado).toLocaleString(
                            "en",
                            {
                              style: "currency",
                              currency: "DOP",
                            }
                          )}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "13px" }}>
                          {parseFloat(item.montoARS).toLocaleString("en", {
                            style: "currency",
                            currency: "DOP",
                          })}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "13px" }}>
                          {parseFloat(item.montoAfiliado).toLocaleString("en", {
                            style: "currency",
                            currency: "DOP",
                          })}
                        </StyledTableCell>

                        <TableCell>
                          <button
                            className="btn btn-danger ms-2"
                            onClick={() => HandleDeleteTable(index)}
                          >
                            <DeleteIcon />
                          </button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell>
                        {MsgValidProced.detalle}
                      </StyledTableCell>
                      <StyledTableCell>{Mensaje}</StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <StyledTableRow>
                    <StyledTableCell
                      style={{ fontSize: "13px", color: "black" }}
                    >
                      {" "}
                      Total General
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell
                      style={{ fontSize: "13px", color: "black" }}
                    >
                      Total Valor del Servicio
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ fontSize: "13px", color: "black" }}
                    >
                      Total Cobertura ARS
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ fontSize: "13px", color: "black" }}
                    >
                      Total Diferencia afiliado
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell
                      style={{ fontSize: "13px", color: "black" }}
                    >
                      Montos
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell
                      style={{ fontSize: "13px", color: "black" }}
                    >
                      {parseFloat(montoRecTotal).toLocaleString("en", {
                        style: "currency",
                        currency: "DOP",
                      })}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ fontSize: "13px", color: "black" }}
                    >
                      {parseFloat(montoARSTotal).toLocaleString("en", {
                        style: "currency",
                        currency: "DOP",
                      })}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ fontSize: "13px", color: "black" }}
                    >
                      {parseFloat(montoAfilTotal).toLocaleString("en", {
                        style: "currency",
                        currency: "DOP",
                      })}
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </StyledTableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Container>
          {/* -------- Botones para enviar o cancelar los servicios agregados -------- */}

          <form onSubmit={HandleSubmitCerrarSesion}>
            <div className="container ">
              {Respuesta && Respuesta ? (
                <div className="row py-3 justify-content-between">
                  <div className="col-auto ">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={HandleCancelarProcedimiento}
                      style={{ fontSize: 14 }}
                    >
                      CANCELAR
                    </button>
                  </div>
                  <div className="col-auto ">
                    <button
                      type="button"
                      className="btn btn-success"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={HandleValidContentTable}
                      style={{ fontSize: 14 }}
                    >
                      ENVIAR
                    </button>
                  </div>
                </div>
              ) : (
                <div className="row py-3 justify-content-between">
                  <div className="col-auto ">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={HandleCancelarProcedimiento}
                      style={{ fontSize: 14 }}
                    >
                      CANCELAR
                    </button>
                  </div>
                  <div className="col-auto ">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={HandleValidContentTable}
                      style={{ fontSize: 14 }}
                    >
                      ENVIAR
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Modal de confirmacion de los datos a enviar*/}
            <div
              className="modal fade"
              id="exampleModal"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      REGISTRO DE AUTORIZACIÓN DE SERVICIOS MÉDICOS
                    </h5>
                  </div>
                  <div className="modal-body">
                    <div className="mt-1 ">
                      <div className="row d-flex flex-row align-items-center ">
                        <div className="col-lg-12 col-md-12 col-sm-12 ">
                          <div className="alert alert-primary  " role="alert">
                            <div>
                              <div className="alert-heading row justify-content-center">
                                <div className="col-auto">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    fill="currentColor"
                                    class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="Warning:"
                                  >
                                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                  </svg>
                                </div>
                                <div className="col-auto text-center">
                                  <h4>AVISO</h4>
                                </div>
                              </div>
                              <p className="mb-0">
                                Haz click en el botón ACEPTAR si estás de
                                acuerdo con los servicios médicos autorizados
                              </p>
                              <hr />
                              <p>
                                Una vez que aceptes guardar la información, no
                                podrás realizar modificaciones.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer ">
                    <div className="row d-flex flex-row ">
                      <div className="col-lg-auto col-md-auto col-sm-auto  ">
                        <button
                          type="button"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          style={{ fontSize: 14 }}
                        >
                          REVISAR
                        </button>
                      </div>

                      <div className="col-lg-auto col-md-auto col-sm-auto ">
                        <button
                          type="submit"
                          className="btn btn-success"
                          data-bs-toggle="modal"
                          data-bs-target="#cerrarSesionModal"
                          onClick={HandleCerrarSession}
                          style={{ fontSize: 14 }}
                        >
                          ACEPTAR
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          {/* Modal de Cerrar Sesion para mostrar los datos */}
          <div
            className="modal"
            id="cerrarSesionModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Datos de Autorización
                  </h5>
                </div>
                <div className="modal-body">
                  <div className="mt-1 ">
                    {MsgValidProced !== "OK" && MsgValidProced !== "OK" ? (
                      <div className="col-lg-8 col-md-6 col-sm-6 ">
                        <div className="row ">
                          <div className="col-lg-6 col-md-6 col-sm-8">
                            <ReactLoading
                              type="spokes"
                              color="#0000FF"
                              height={100}
                              width={50}
                            />
                          </div>
                        </div>
                      </div>
                    ) : MsgValidProced === "OK" && MsgValidProced === "OK" ? (
                      <div className="row d-flex flex-row align-items-center justify-content-center ">
                        <div className="col-lg-8 col-md-6 col-sm-6 ">
                          <div className="row ">
                            <div className="col-lg-6 col-md-8 col-sm-8">
                              <h5 className="fs-6">AUTORIZACIÓN:</h5>
                            </div>

                            <div className="col-lg-4 col-md-4 col-sm-8 ">
                              <p>{contentClosedSesion.codAutorizacion}</p>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-8 col-md-6 col-sm-6 ">
                          <div className="row ">
                            <div className="col-lg-6 col-md-6 col-sm-8">
                              <h5 className="fs-6">TOTAL:</h5>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-8">
                              <p>
                                {parseFloat(
                                  contentClosedSesion.montoReclamado
                                ).toLocaleString("en", {
                                  style: "currency",
                                  currency: "DOP",
                                })}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-8 col-md-6 col-sm-6 ">
                          <div className="row ">
                            <div className="col-lg-6 col-md-8 col-sm-8">
                              <h5 className="fs-6">COBERTURA:</h5>
                            </div>

                            <div className="col-lg-4 col-md-4 col-sm-8">
                              <p>
                                {parseFloat(
                                  contentClosedSesion.montoARS
                                ).toLocaleString("en", {
                                  style: "currency",
                                  currency: "DOP",
                                })}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-8 col-md-6 col-sm-6 ">
                          <div className="row ">
                            <div className="col-lg-6 col-md-6 col-sm-8">
                              <h5 className="fs-6">DIFERENCIA AFILIADO:</h5>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-8">
                              <p>
                                {parseFloat(
                                  contentClosedSesion.montoAfiliado
                                ).toLocaleString("en", {
                                  style: "currency",
                                  currency: "DOP",
                                })}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="errorlabel ms-5 mt-3">
                        {MsgValidProced}
                      </div>
                    )}
                  </div>
                </div>
                <div className="modal-footer d-flex flex-row align-items-center justify-content-arounds ">
                  <div className="row ">
                    <div className="col-lg-auto">
                      <button
                        className="btn btn-secondary"
                        onClick={HandleRefreshAfterTicket}
                      >
                        TICKET
                      </button>
                    </div>
                    <div className="d-none">
                      <ViewerTicketReport
                        imprimirContenido={imprimirContenido}
                      />
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-lg-auto">
                      <a
                        ref={linkPDFRef}
                        href="/reports"
                        target="_blank"
                        style={{ fontSize: 14 }}
                        rel="noopener noreferrer"
                      >
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          className="btn btn-info"
                          onClick={HandleRefreshAfterPDF}
                          style={{ fontSize: 14 }}
                        >
                          IMPRIMIR
                        </button>
                      </a>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-auto">
                      <button
                        type="button"
                        className="btn btn-danger"
                        data-bs-dismiss="modal"
                        onClick={HandleRefreshWindows}
                        style={{ fontSize: 14 }}
                      >
                        CERRAR
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Box>
    </Container>
  );
};

export default FormAddServices;
